module.exports = __webpack_public_path__ + "fonts/msyhbd.c8d4adc0.ttf";